import { Component } from "solid-js";

interface WatchesIconProps {
  class?: string;
}

export const WatchesIcon: Component<WatchesIconProps> = (props) => {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      class={props.class}
    >
      <path
        d="M21.3334 9.14267V5.33333C21.3334 4.59733 20.7361 4 20.0001 4H12.0001C11.2641 4 10.6667 4.59733 10.6667 5.33333V9.14267"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M10.6667 22.8574V26.6667C10.6667 27.4027 11.2641 28 12.0001 28H20.0001C20.7361 28 21.3334 27.4027 21.3334 26.6667V22.8574"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M10.6667 22.8573H21.3333C22.8067 22.8573 24 21.664 24 20.1906V12C24 10.5266 22.8067 9.33331 21.3333 9.33331H10.6667C9.19333 9.33331 8 10.5266 8 12V20.1906C8 21.6626 9.19333 22.8573 10.6667 22.8573Z"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M14.6667 17.3333V13.3333"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M18.6667 17.3334H14.6667"
        class="stroke-inherit"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
